import type { QueryClient } from "@tanstack/react-query";
import { fetchUserBalanceStatements } from "@/features/balance/utils/fetch-student-statements";
import {
  defaultMemberFamilyStatementRequests,
  STATEMENT_SUMMARY_PAGE_SIZE,
  STUDENT_STATEMENT_PAGE_SIZE,
  USER_BALANCE_STATEMENTS_STALE_TIME_MS,
  userBalanceStatementsQueryKey,
} from "@/features/balance/utils/user-balance-statements-query";

export async function prefetchUserBalanceStatements(
  userId: number,
  queryClient: QueryClient,
  accessToken: string,
  tenantId: number,
) {
  const { summary, table } = defaultMemberFamilyStatementRequests(userId);

  try {
    await Promise.all([
      queryClient.prefetchQuery({
        queryKey: userBalanceStatementsQueryKey(
          userId,
          summary,
          1,
          STATEMENT_SUMMARY_PAGE_SIZE,
        ),
        queryFn: () =>
          fetchUserBalanceStatements({
            accessToken,
            tenantId,
            userId,
            request: summary,
            page: 1,
            pageSize: STATEMENT_SUMMARY_PAGE_SIZE,
          }),
        staleTime: USER_BALANCE_STATEMENTS_STALE_TIME_MS,
      }),
      queryClient.prefetchQuery({
        queryKey: userBalanceStatementsQueryKey(
          userId,
          table,
          1,
          STUDENT_STATEMENT_PAGE_SIZE,
        ),
        queryFn: () =>
          fetchUserBalanceStatements({
            accessToken,
            tenantId,
            userId,
            request: table,
            page: 1,
            pageSize: STUDENT_STATEMENT_PAGE_SIZE,
          }),
        staleTime: USER_BALANCE_STATEMENTS_STALE_TIME_MS,
      }),
    ]);
  } catch (error) {
    console.error("[BalancePage SSR] family statements failed", { userId, error });
  }

  return queryClient;
}
